import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import "./OrderConfirmed.css";

const OrderConfirmed = () => {
	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, []);

	return (
		<>
			<Helmet>
				<title>Order Confirmed - Aire Studio</title>
			</Helmet>

			<div className="confirmed-page">
				<motion.div
					className="confirmed-content"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				>
					<div className="confirmed-check">
						<svg width="48" height="48" viewBox="0 0 48 48" fill="none">
							<circle cx="24" cy="24" r="23" stroke="currentColor" strokeWidth="1.5" />
							<path d="M15 24l6 6 12-12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<p className="confirmed-label">Order Confirmed</p>
					<h1 className="confirmed-title">Thank You</h1>
					<p className="confirmed-message">
						Your order has been placed successfully. We'll send a confirmation email
						with your order details and tracking information shortly.
					</p>
					<div className="confirmed-actions">
						<Link to="/collections" className="confirmed-btn-primary">
							Continue Shopping
						</Link>
						<Link to="/" className="confirmed-btn-secondary">
							Return Home
						</Link>
					</div>
				</motion.div>
			</div>
		</>
	);
};

export default OrderConfirmed;
